import { Box, Slide } from '@mui/material';
import useAppStore from '../../../store/app';
import RequestTypeSelector from './RequestTypeSelector';
import useRequestStore from '../../../store/request';
import { useState } from 'react';
import RequestPersonalData from './RequestPersonalData';
import RequestDetails from './RequestDetails';
import { useRef } from 'react';
import { toast } from 'react-toastify';

const steps = [
  {
    id: 'type',
    component: RequestTypeSelector,
  },
  {
    id: 'details',
    component: RequestDetails,
  },
  {
    id: 'contact',
    component: RequestPersonalData,
  },
];

export default function RequestForm() {
  const [step, setStep] = useState('type');
  const [direction, setDirection] = useState('left');
  const container = useRef(null);
  const completeRequestForm = useAppStore((state) => state.completeRequestForm);
  const data = useRequestStore((state) => state.data);
  const addStepData = useRequestStore((state) => state.addStepData);
  const clearData = useRequestStore((state) => state.clearData);

  async function next(stepData) {
    setDirection('left');
    addStepData(stepData);
    if (step === steps[steps.length - 1].id) {
      const updatedData = { ...data, ...stepData };
      const res = await fetch(
        `${import.meta.env.VITE_LIVE_URL}webhooks/codemeta/request`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(updatedData),
        },
      );
      if (!res.ok) {
        toast.error(
          'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.',
        );
      } else {
        toast.success('Ihre Anfrage wurde erfolgreich abgeschickt!');
      }
      clearData();
      completeRequestForm();
    } else {
      setStep(steps[steps.findIndex((s) => s.id === step) + 1].id);
    }
  }

  function back(stepData) {
    setDirection('right');
    addStepData(stepData);
    setStep(steps[steps.findIndex((s) => s.id === step) - 1].id);
  }

  return (
    <Box
      sx={{ display: 'flex', flexFlow: 'column', gap: '16px', width: '450px' }}
      ref={container}
    >
      {steps.map((s) => {
        if (s.id === step) {
          return (
            <Slide
              in={true}
              key={s.id}
              container={container.current}
              direction={direction}
              mountOnEnter
              unmountOnExit
              timeout={300}
            >
              <Box>
                <s.component key={s.id} next={next} back={back} />
              </Box>
            </Slide>
          );
        }
        return null;
      })}
    </Box>
  );
}
